import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M4.5 9A3.75 3.75 0 1 0 9 9M4.5 9V2.25H9V9M9 2.25h1.5M9 4.5h1.5M9 6.75h1.5M14.25 5.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M6.75 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0 0V8.25"
    }, null, -1)
  ]))]))
}
export default { render: render }